// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.asset-list-table tr {
  border-bottom: 1px solid lightgray;
}

.asset-list-table th {
  padding-left: 5px;
}

.asset-list-table.checkbox {
  padding: 100px;
}

.sortable-header-button {
  font-weight: normal;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./../app-web/public/app/assetLibrary/components/AssetTableView/AssetTableView.scss"],"names":[],"mappings":"AAAA;EACI,kCAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,mBAAA;EACA,eAAA;AACJ","sourcesContent":[".asset-list-table tr {\n    border-bottom: 1px solid lightgray;\n}\n\n.asset-list-table th {\n    padding-left: 5px;\n}\n\n.asset-list-table.checkbox {\n    padding: 100px;\n}\n\n.sortable-header-button {\n    font-weight: normal;\n    font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
